import httpClient from "../lib/HttpClient"

export const createProductHttp = async (addInputDTO) => {
    return await httpClient.post("product/add",addInputDTO)
}
export const updateProductHttp = async (updateInputDTO) => {
    return await httpClient.put("product/update",updateInputDTO)
}
export const deleteProductHttp = async (id) => {
    return await httpClient.delete(`product/delete?id=${id}`)
}
export const getProductHttp = async (id) => {
    return await httpClient.get(`product/get?id=${id}`)
}
export const getProductsHttp = async (paginationInputDTO) => {
    return await httpClient.post("product/get",paginationInputDTO)
}